import styled from 'styled-components'

const SkonsolidowanePolaczenieSpolekStyle = styled.div`
  .checkbox {
    width: 100%;
    background: #fff;
    display: flex;
    align-items: flex-start;
    margin-bottom: 4px;
    padding: 12px 20px;
  }

  .element {
    background: #fff;
    border-radius: 3px;
    padding: 8px 20px 20px 25px;
    margin-bottom: 4px;
  }
  .element:hover {
    border-left: 5px solid ${props => props.theme.palette.primary.main};
    padding-left: 20px;
  }

  .radioGroup {
    display: flex;
    justify-content: space-between;
  }

  .nazwaJednostki{
    display: flex;
  }

  .szczegolyPolaczenia{
    width: 100%;
    height: 36px;
    background: ${props => props.theme.black4onBlack4};
    padding: 12px 20px 10px;
    font-family: 'Ubuntu';
    font-size: 11px;
    color: ${props => props.theme.black38};
    margin: 0 0 12px 0;
  }
`
export default SkonsolidowanePolaczenieSpolekStyle
